import types from 'helpers/constants';

const initialState = {
  wholesalers: [],
  loading: true,
};

// eslint-disable-next-line func-style, default-param-last -- FIXME
function Wholesalers(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_WHOLESALERS:
      return {
        ...state,
        wholesalers: action.payload.wholesalers,
        loading: false,
      };
    default:
      return state;
  }
}

export default Wholesalers;
